import _startCase from 'lodash/startCase';

export const PENDING_PAYMENT = 'PENDING PAYMENT';
export const PENDING = 'PENDING';
export const ACCEPTED = 'ACCEPTED';
export const REJECTED = 'REJECTED';
export const SHIPPED = 'SHIPPED';
export const COMPLETED = 'COMPLETED';

export const ORDER_STATUS = {
  pending_payment: PENDING_PAYMENT,
  pending: PENDING,
  accepted: ACCEPTED,
  rejected: REJECTED,
  shipped: SHIPPED,
  completed: COMPLETED,
};

export const CURRENCY_SYMBOL = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  CAD: 'CAD',
  null: '',
};

export const toStartCase = (str) => {
  if (!str) return '';
  return _startCase(str.toLowerCase());
};

// workaround for disabling autoComplete of country field on Safari. \u200C is the zero width non-joiner
export const escapedCountry = 'Coun\u200Ctry';
export const escapedCountryField = 'coun\u200Ctry';
